import {
  GET_MANAGER_APP_TRACK_BY_DATE_LIST_FAIL,
  GET_MANAGER_APP_TRACK_BY_DATE_LIST_REQUEST,
  GET_MANAGER_APP_TRACK_BY_DATE_LIST_SUCCESS,
  GET_MANAGER_APP_TRACK_LIST_FAIL,
  GET_MANAGER_APP_TRACK_LIST_REQUEST,
  GET_MANAGER_APP_TRACK_LIST_SUCCESS,
  GET_MANAGER_APP_TRACK_BY_DEP_LIST_FAIL,
  GET_MANAGER_APP_TRACK_BY_DEP_LIST_REQUEST,
  GET_MANAGER_APP_TRACK_BY_DEP_LIST_SUCCESS,
} from "../../types/manager/appTrackTypes";

export const getManagerAppTrackReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MANAGER_APP_TRACK_LIST_REQUEST:
      return {
        ...state,
        appLoading: true,
      };
    case GET_MANAGER_APP_TRACK_LIST_SUCCESS:
      return {
        ...state,
        appLoading: false,
        appInfo: payload,
        appError: "",
      };
    case GET_MANAGER_APP_TRACK_LIST_FAIL:
      return {
        ...state,
        appLoading: false,
        appError: payload,
        appInfo: {},
      };
    default:
      return state;
  }
};

export const getManagerAppTrackByDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MANAGER_APP_TRACK_BY_DATE_LIST_REQUEST:
      return {
        ...state,
        appLoading: true,
      };
    case GET_MANAGER_APP_TRACK_BY_DATE_LIST_SUCCESS:
      return {
        ...state,
        appLoading: false,
        appInfo: payload,
        appError: "",
      };
    case GET_MANAGER_APP_TRACK_BY_DATE_LIST_FAIL:
      return {
        ...state,
        appLoading: false,
        appError: payload,
        appInfo: {},
      };
    default:
      return state;
  }
};

export const getDeptAppTrackByDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MANAGER_APP_TRACK_BY_DEP_LIST_REQUEST:
      return {
        ...state,
        depAppLoading: true,
      };
    case GET_MANAGER_APP_TRACK_BY_DEP_LIST_SUCCESS:
      return {
        ...state,
        depAppLoading: false,
        depAppInfo: payload,
        depAppError: "",
      };
    case GET_MANAGER_APP_TRACK_BY_DEP_LIST_FAIL:
      return {
        ...state,
        depAppLoading: false,
        depAppError: payload,
        depAppInfo: {},
      };
    default:
      return state;
  }
};